import { useSyncExternalStore } from 'react'

let isAddMoreImages = false
const listeners = new Set<() => void>()

export const setIsAddMoreImagesView = (value: boolean) => {
  isAddMoreImages = value
  listeners.forEach((listener) => listener())
}

export const useIsAddMoreImagesView = () =>
  useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => isAddMoreImages,
  )
